import React, { useState, useEffect, useRef, Fragment } from "react";
import { Dialog } from "primereact/dialog";
import { Image } from 'primereact/image';
import sideBarRight from "../../../assets/images/sidebarright.svg";
import { Tag } from 'primereact/tag';
import { useReactToPrint } from "react-to-print";
import ReportTemplate from "../ReportTemplate";
import moment from 'moment/moment';
import { CertificatedSubInitiateRequest, CertificatedSubRequestFundingAccountDetails, CertificatedSubRequestSpecificTeacherDates, CertificatedSubRequestTeacherData, CertificatedSubRequestTransactionCycle, Employee, FundingAccountType } from "../../../models";
import { DataStore, SortDirection } from "aws-amplify";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Timeline } from 'primereact/timeline';
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { GetValueFromArray, graphQLGetAllData, graphQLFindRecordById } from '../../../helper/commonfunctions';
import handleDateSelect from '../../../helper/convertDateIntoPSTFormat';


const ViewPopUp = (props) => {


    console.log("viewlog",props);

    let [events, setEvents] = useState([]);
    let [submittedBy, setSubmittedBy] = useState({});
    const [globalReportId, setReportId] = useState('');
    const [schoolOrDeptName, setSchoolOrDeptName] = useState('');
    const [requestDate, setRequestDate] = useState('');
    const [status, setStatus] = useState('');
    const [specifyPurpose, setSpecifyPurpose] = useState('');
    const [fundingDetails, setFundingDetails] = useState([]);
    const [approvalFinalData, setApprovalFinalData] = useState([]);

    //print report functionality
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    //state
    const [reportInformation, setReportInformation] = useState([]);
    const [showReport, setShowReport] = useState(false);

    const getInformationOfParticularReport = async (reportId) => {
        const cognito = new AWS.CognitoIdentityServiceProvider();

        //get teacher data from CertificatedSubRequestTeacherData table
        // var certificatedSubRequestTeacherDataResponses = await DataStore.query(CertificatedSubRequestTeacherData, (c) => c.reportId.eq(reportId));
        var certificatedSubRequestTeacherDataResponses = await graphQLGetAllData("listCertificatedSubRequestTeacherData", [{ reportId: { eq: reportId } }])


        let teacherDetails = [];
        for (let i = 0; i < certificatedSubRequestTeacherDataResponses.length; i++) {

            //get dates of that particular teacher from CertificatedSubRequestSpecificTeacherDates 
            // var certificatedSubRequestSpecificTeacherDatesResponses = await DataStore.query(CertificatedSubRequestSpecificTeacherDates, (c) => c.teacherId.eq(certificatedSubRequestTeacherDataResponses[i].id));

            var certificatedSubRequestSpecificTeacherDatesResponses = await graphQLGetAllData("listCertificatedSubRequestSpecificTeacherDates", [{ teacherId: { eq: certificatedSubRequestTeacherDataResponses[i].id } }])

            // var employeeResponses = await DataStore.query(Employee, (c) => c.id.eq(certificatedSubRequestTeacherDataResponses[i].teacherId));

            var employeeResponses = await graphQLFindRecordById("getEmployee", certificatedSubRequestTeacherDataResponses[i].teacherId)


            let dateArray = [];
            for (let j = 0; j < certificatedSubRequestSpecificTeacherDatesResponses.length; j++) {
                dateArray.push(certificatedSubRequestSpecificTeacherDatesResponses[j].date);
            }

            let obj = {
                teacherName: employeeResponses.employee_name,
                datesNeeded: dateArray,
                indicateIf: certificatedSubRequestTeacherDataResponses[i].indicateIf,
                gradeOrSubject: certificatedSubRequestTeacherDataResponses[i].gradeOrSubject,
                notes: certificatedSubRequestTeacherDataResponses[i].note,
                updatedAT: certificatedSubRequestTeacherDataResponses[i].updatedAt
            }
            teacherDetails.push(obj);
        }

        teacherDetails = teacherDetails.sort((a, b) => a.teacherName.localeCompare(b.teacherName));

        setReportInformation(teacherDetails);

        try {
            // const certificatedSubRequestFundingAccountDetailsResponses = await DataStore.query(CertificatedSubRequestFundingAccountDetails, (c) => c.reportId.eq(reportId));
            let certificatedSubRequestFundingAccountDetailsResponses = await graphQLGetAllData("listCertificatedSubRequestFundingAccountDetails", [{ reportId: { eq: reportId } }])
            certificatedSubRequestFundingAccountDetailsResponses = certificatedSubRequestFundingAccountDetailsResponses.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            let fundingDetails = [];

            for (let i = 0; i < certificatedSubRequestFundingAccountDetailsResponses.length; i++) {
                const fundingAccountTypeId = certificatedSubRequestFundingAccountDetailsResponses[i].fundingAccountTypeId;
                // const deptNames = await DataStore.query(FundingAccountType, (c) => c.id.eq(fundingAccountTypeId));
                const deptNames = await graphQLFindRecordById("getFundingAccountType", fundingAccountTypeId)

                if (deptNames) {
                    const obj = {
                        departmentName: deptNames?.fundingAccountType, // Use optional chaining
                        programAccountNumber: certificatedSubRequestFundingAccountDetailsResponses[i].accountNumber,
                        remark: certificatedSubRequestFundingAccountDetailsResponses[i].remarks,
                        percentage: certificatedSubRequestFundingAccountDetailsResponses[i].percentage,
                    };

                    fundingDetails.push(obj);
                } else {
                    console.warn(`No department found for fundingAccountTypeId ${fundingAccountTypeId}`);
                }
            }

            setFundingDetails(fundingDetails);
        } catch (error) {
            console.error("Error:", error);
        }


        //get particular report transaction cycle data and metadata
        try {
            // const particularReportMetaDataResponse = await DataStore.query(CertificatedSubInitiateRequest,
            //     (c) => c.id.eq(reportId)
            // );

            const particularReportMetaDataResponse = await graphQLFindRecordById("getCertificatedSubInitiateRequest", reportId)

            // const particularReportTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
            //     (c) => c.reportId.eq(reportId),
            //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            console.log("particularReportTransactionCycleResponse", particularReportTransactionCycleResponse)
            let currentDateTime = moment();
            currentDateTime = moment(currentDateTime).format("YYYY-MM-DD HH:mm:ss");
            if (particularReportTransactionCycleResponse && particularReportMetaDataResponse) {

                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            //console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                        let fullName = userFirstName + " " + userLastName

                        let empTitle = '';
                        if (particularReportMetaDataResponse.firstApproverId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            if (particularReportTransactionCycleResponse[i]?.approver_level === "Initiator") {
                                empTitle = "Initiator"
                            } else {
                                empTitle = 'Site Admin/Dept Head';
                            }
                        } else if (particularReportMetaDataResponse?.secondApproverId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        } else if (particularReportMetaDataResponse?.thirdApproverId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        } else if (particularReportMetaDataResponse?.payrollId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Sub Desk';
                        } else if (particularReportTransactionCycleResponse[i].status === "RESUBMITTED") {
                            if (particularReportMetaDataResponse?.submittedBy === particularReportTransactionCycleResponse[i].to_Employee_Id) {
                                empTitle = "Initiator"
                            } else {
                                empTitle = "Super Admin"
                            }
                        }
                        else {
                            if (particularReportMetaDataResponse.submittedBy === particularReportTransactionCycleResponse[i].to_Employee_Id) {
                                empTitle = "Initiator"
                            } else {
                                empTitle = (particularReportTransactionCycleResponse[i]?.toEmpDesignation) ? particularReportTransactionCycleResponse[i]?.toEmpDesignation : "Super Admin";
                            }
                        }

                        if (i == 0) {
                            let initiatorUsers;

                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: particularReportMetaDataResponse.submittedBy,
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let userCodeEmp1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:userCode") : ''
                            let initiatorFullName = userFirstName1 + " " + userLastName1;

                            let appDate = particularReportTransactionCycleResponse[i].createdAt;

                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                empCode: userCodeEmp1,
                                status: 'Submitted',
                                date: (appDate) ? 
                                moment(appDate).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm ') : 
                                // handleDateSelect(appDate) :
                               null,
                                // handleDateSelect(currentDateTime),
                                    // moment(particularReportTransactionCycleResponse[i].customUpdatedAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A")
                                    // : null
                            }
                            setSubmittedBy(obj);
                            transactionArray.push(obj);
                        }


                        let finalStatus = (particularReportTransactionCycleResponse[i].status == 'APPROVED') ? 'Approved' :
                            (particularReportTransactionCycleResponse[i].status == 'CLOSED') ? 'Closed' :
                                (particularReportTransactionCycleResponse[i].status == 'OPEN')||
                                ( particularReportTransactionCycleResponse[i].status == 'Pending for Approval Budget Clerk')||
                                (particularReportTransactionCycleResponse[i].status == 'Pending for Approval Budget Manager')
                                 ? 'Pending' :
                                (particularReportTransactionCycleResponse[i].status == 'REJECTED') ? 'Rejected' :
								// (particularReportTransactionCycleResponse[i].status == 'Reviewed & resubmitted') ? 'Pending' :
								(particularReportTransactionCycleResponse[i].status == 'Reviewed & resubmitted') ? 'Reviewed & resubmitted' :
                                    particularReportTransactionCycleResponse[i].status;


                        let datetime = particularReportTransactionCycleResponse[i].updatedAt;


                        let obj = {
                            empName: fullName,
                            empTitle: empTitle,
                            status: finalStatus,
                            date: particularReportTransactionCycleResponse[i].status !== 'OPEN' ? 
                            ((datetime) ? 
                            moment(datetime).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm ') :
                            // handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt) : 
                            moment(currentDateTime).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm ')): null,
                            isApproved: particularReportTransactionCycleResponse[i].isApproved,
                            // isApproved:''
                            // (particularReportTransactionCycleResponse[i].customUpdatedAt ?
                            //     moment(particularReportTransactionCycleResponse[i].customUpdatedAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A")
                            //     : null)
                            // updatedAt:appDate,
                            // isApproved: particularReportTransactionCycleResponse[i].isApproved,                            
                            //status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover[0].status) == 'PENDING' ? 'Pending' : statusReport)),
                            //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                        }
                        transactionArray.push(obj);
                    }



                }
                console.log("transactionArray", transactionArray)
                setEvents(transactionArray);

            }
        } catch (err) {
            console.log("Error in particularReportTransactionCycleResponse view popup", err);
        }

    }

    useEffect(() => {
        getDateMeta()
    }, [props.specificReportDataForView])

    const getDateMeta = () => {

        const { reportId = '', schoolOrDeptName = '', requestDate = '', status = '', purpose = '', approvalFinalData = [] } = props.specificReportDataForView;

        setSchoolOrDeptName(schoolOrDeptName);
        setRequestDate(requestDate);
        setStatus(status);
        setStatus(status);
        setSpecifyPurpose(purpose);
        setApprovalFinalData(props.specificReportDataForView?.approvalFinalData?.reverse());

        if (reportId != '') {
            setReportId(reportId);
            getInformationOfParticularReport(reportId);
        }
    }
    const approveStatusOptions = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';

            case 'Submitted':
                return 'info';

            case 'Pending':
                return 'warning';

            case 'Closed':
                return 'success';
            case 'Approved':
                return 'success';
                case 'Reviewed & resubmitted':
                    return 'info'; 
            default:
                return null;
        }
    };

    return (
        <>
            <Dialog className="relative reports-popup" visible={props.viewPopUp} position='right'
                style={{ width: '70vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => { props.closePopUp(); setShowReport(false); }} draggable={false} resizable={false}>
                <div className="grid grid-cols-2 lg:grid-cols-12 h-screen">
                    <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                        <div className="p-5">
                            <div onClick={() => { props.closePopUp(); setShowReport(false); }} className="py-3">
                                <Image src={sideBarRight} alt="user" width="24" height="24" /></div>
                            {
                                (!showReport) ?
                                    <div>
                                        <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District</div>
                                        <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Substitute Request Certificated</div>

                                        <div className="pt-3">
                                            <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                <div className="font-medium">School or Department </div>
                                                <div className="font-semibold ">{schoolOrDeptName}</div>
                                            </div>
                                            <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                <div className="font-medium">Date </div>
                                                <div className="font-semibold ">{requestDate}</div>
                                            </div>

                                            <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                <div className="font-medium">Status </div>
                                                <Tag severity="" value={status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                {/* <div >Approved</div> */}
                                            </div>
                                        </div>

                                        {/* <div className="card">
                                            <DataTable value={reportInformation}>
                                                <Column field="teacherName" header="Teacher(s) Name" sortable ></Column>
                                                <Column field="datesNeeded" header="Date(s) Needed" sortable ></Column>
                                                <Column field="indicateIf" header="Indicate If" sortable ></Column>
                                                <Column field="gradeOrSubject" header="Grade(element) or Subject(second)" sortable ></Column>
                                                <Column field="notes" header="Notes" sortable ></Column>
                                            </DataTable>
                                        </div> */}
                                        {
                                            (reportInformation.length > 0) ?

                                                <Table className="certificatedPrintTable">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Teacher(s) Name</TableCell>
                                                            <TableCell>Date(s) Needed</TableCell>
                                                            <TableCell>Indicate If</TableCell>
                                                            <TableCell>Grade(element) or Subject(second)</TableCell>
                                                            <TableCell>Notes</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        {reportInformation.map((item, i) => (
                                                            <Fragment>
                                                                <TableRow>
                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                    >
                                                                        {item.teacherName}
                                                                    </TableCell>
                                                                    <TableCell className="w-[180px]">
                                                                        {item.datesNeeded.map((date, detailIndex) => (

                                                                            <TableRow className="bg-[#F2F4F7]">
                                                                                <TableCell>{moment(date).format('MM/DD/YYYY')}</TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableCell>
                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                    >
                                                                        {item.indicateIf}
                                                                    </TableCell>
                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                    >
                                                                        {item.gradeOrSubject}
                                                                    </TableCell>
                                                                    <TableCell className="bg-[#F2F4F7]"
                                                                    >
                                                                        {item.notes}
                                                                    </TableCell>
                                                                </TableRow>
                                                            </Fragment>
                                                        ))}
                                                    </TableBody>
                                                </Table>

                                                : null
                                        }

                                        <div className="pt-3">
                                            <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                <div className="font-medium">Purpose</div>
                                                <div className="font-semibold ">{specifyPurpose}</div>
                                            </div>
                                            <div className="text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                <div className="font-medium">Funding Account</div>
                                                {
                                                    fundingDetails.map((currentItem, index) => {
                                                        return (
                                                            <div key={index} className="border p-2">
                                                                <div className="flex justify-between">
                                                                    <div className="font-light py-3">Department</div>
                                                                    <div className="font-semibold ">{currentItem.departmentName}</div>
                                                                </div>
                                                                <div className="flex justify-between">
                                                                    <div className="font-light py-3">Remark</div>
                                                                    <div className="font-semibold ">{ currentItem.remark ? currentItem.remark : '-' }</div>
                                                                </div>
                                                                <div className="flex justify-between">
                                                                    <div className="font-light">Program Account #</div>
                                                                    <div className="font-semibold ">{currentItem.programAccountNumber}</div>
                                                                </div>
                                                                <div className="flex justify-between">
                                                                    <div className="font-light">Percentage</div>
                                                                    <div className="font-semibold ">{currentItem.percentage}</div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <ReportTemplate
                                            submittedBy={submittedBy}
                                            schoolOrDeptName={schoolOrDeptName}
                                            requestDate={requestDate}
                                            status={status}
                                            reportInformation={reportInformation}
                                            fundingDetails={fundingDetails}
                                            specifyPurpose={specifyPurpose}
                                            events={events}
                                            approvalFinalData={approvalFinalData}
                                        />
                                    </div>
                            }
                            <div className='w-full grid grid-cols-1 justify-center gap-4'>

                                {
                                    (showReport) ?
                                        <button onClick={handlePrint} className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                            <i className="mr-3 gusd-print-outline"></i><span>Print / Download</span>
                                        </button> :
                                        <button
                                            onClick={() => setShowReport(true)}
                                            className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                            <i className="mr-3 gusd-document"></i><span>Show Report</span>
                                        </button>

                                }

                            </div>

                            <div style={{ display: "none" }} >
                                <div ref={componentRef}>
                                    <ReportTemplate
                                        submittedBy={submittedBy}
                                        schoolOrDeptName={schoolOrDeptName}
                                        requestDate={requestDate}
                                        status={status}
                                        reportInformation={reportInformation}
                                        fundingDetails={fundingDetails}
                                        events={events}
                                        specifyPurpose={specifyPurpose}
                                        approvalFinalData={approvalFinalData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                        <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                            <div className="card custTable">

                                <Timeline value={events}
                                    opposite={(item) => <Tag
                                        severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                        value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                            <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                            <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                            <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                            <div className="text-color-secondary text-[9px] ml-2">{item.date !== null ? item.date : null }</div>

                                        </div>} />

                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default ViewPopUp